module.exports = __webpack_public_path__ + "img/ic_scb_easy.68dd6a2f.jpg";